import { Component } from '@angular/core';
import { RouteConfig, ROUTER_DIRECTIVES } from '@angular/router-deprecated';
import { InstitutionComponent } from '../institution/InstitutionComponent';
import { ReadinessComponent } from '../readiness/ReadinessComponent';
import { UsrMgtComponent } from '../users/UsrMgtComponent';
import { UserSyncComponent } from '../users/UserSyncComponent';
import { ScaleValidateComponent } from '../scalevalidate/ScaleValidateComponent';
import { TemplateMgtComponent } from '../templatemgt/TemplateMgtComponent';
import { SystemLockComponent } from '../system/SystemLockComponent';
import { ExportComponent } from '../export/ExportComponent';
import { LoadingService } from '../services';
import { LoadIndicator } from '../common/LoadIndicator';

@Component({
    selector: 'main',
    template: require('./main.html'),
    directives: [ ROUTER_DIRECTIVES, LoadIndicator ]
})
@RouteConfig([
    { path: '/institution-lookup', name: 'InstLookup', component: InstitutionComponent, useAsDefault: true },
    { path: '/system-readiness/:id', name: 'SysReadiness', component: ReadinessComponent },
    { path: '/user-management/:id', name: 'UserMgt', component: UsrMgtComponent },
    { path: '/scale-validation/:id', name: 'ScaleValidate', component: ScaleValidateComponent },
    { path: '/system-lock/:id', name: 'SystemLock', component: SystemLockComponent },
    { path: '/template-management', name: 'TemplateMgt', component: TemplateMgtComponent },
    { path: '/sync-usernames', name: 'SyncUserNames', component: UserSyncComponent },
    { path: '/export', name: 'Export', component: ExportComponent }
])
export class MainComponent {
    loader: any;

    constructor(loadingService: LoadingService) {
        this.loader = loadingService;
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/MainComponent.ts
 **/